module.exports = __webpack_public_path__ + "img/trainBackImg.5003ffad.jpg";